import { useMemo } from 'react';
import recommend, { TrendingItemsQuery } from '@algolia/recommend';
import { useAlgoliaConfig } from '~/shared/hooks/useAlgoliaConfig';
import { useQuery } from 'react-query';
import { AlgoliaHit } from '~/templates/blocks/components/carousel/models';

type Options = Omit<TrendingItemsQuery, 'indexName' | 'objectID'>;

export const useTrendingItems = (options?: Options, enabled?: boolean) => {
    const { defaultIndex: indexName, key, token } = useAlgoliaConfig();
    const frequentlyBoughtTogetherQueryKey = ['algoliaTrending', { ...options, indexName }];
    const queries = useMemo(() => [{ indexName, ...options }], [indexName, options]);

    const recommendClient = useMemo(() => recommend(key, token), [key, token]);

    const { data: hits, isLoading } = useQuery<AlgoliaHit[]>(
        frequentlyBoughtTogetherQueryKey,
        async () => {
            const { results } = await recommendClient.getTrendingItems<AlgoliaHit>(queries);
            return results?.[0]?.hits || [];
        },
        {
            enabled,
        }
    );

    return {
        hits,
        isLoading,
    };
};
